export default "__VITE_ASSET__8e081825__"